import CryptoJS from "crypto-js"

const secKey = process.env.REACT_APP_SECRET_TOKEN

export const CreateToken = (data) => {
    let jsonData = JSON.stringify(data)
    let encryptionKey = secKey
    return CryptoJS.AES.encrypt(jsonData, encryptionKey).toString()
}